<div class="space-y-8 mb-2 mt-4">
  @for (videoClip of videoClips(); track videoClip; let i = $index) {
    <div class="flex flex-col gap-2">
      <div class="relative">
        <app-pan-video
          [src]="getLinkForClip(videoClip)"
          (expandedChange)="expandedChange.emit($event)"
        ></app-pan-video>
        @if (extendingClipId() === videoClip.id) {
          <div class="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-black/50 z-10">
            <app-pan-spinner size="lg"></app-pan-spinner>
          </div>
        }
      </div>
      <div class="flex">
        @if (videoClip.is_auto_download) {
          <app-review-clip-not-useful
            [videoClip]="videoClip"
            (report)="report.emit($event)"
          ></app-review-clip-not-useful>
          <div class="flex gap-2 ml-auto">
            <app-pan-button color="primary" (click)="onAddTimeBefore(videoClip)" [disabled]="extendingClipId() !== null">Add 30s Before</app-pan-button>
            <app-pan-button color="primary" (click)="onAddTimeAfter(videoClip)" [disabled]="extendingClipId() !== null">Add 30s After</app-pan-button>
          </div>
        }
      </div>
    </div>
  }
</div>
